import React from "react";
import { Container, Box, Grid, Card, Typography } from "@mui/material";
import SectionHeading from "./SectionHeading";
import { colors, fonts, ui } from "../theme";

const items = [
  {
    param: "Academic Excellence",
    support: "Industry-reviewed modules, unique code sandboxes and modern technology workshops.",
    impact: "Satisfies NAAC Criterion 1.",
  },
  {
    param: "Student Development",
    support: "Intensive training tracks, technical interview support and project mentoring.",
    impact: "Improves progression & employment under NAAC Criterion 5.",
  },
  {
    param: "Industry Interaction",
    support: "Verified industrial partnerships, shared MoUs and direct expert engagement.",
    impact: "Meets NAAC Criterion 3 and NBA Criteria 9 & 10.",
  },
  {
    param: "Research Awareness",
    support: "Technical writing, literature reviews and original software design guidance.",
    impact: "Supports NAAC Criterion 3 (3.1, 3.2, 3.3).",
  },
  {
    param: "Innovation Culture",
    support: "Hands-on engineering labs, design-thinking sessions and hackathon challenges.",
    impact: "Contributes to higher ARIIA and IIC rankings.",
  },
  {
    param: "Faculty Development",
    support: "Specialised tech series across cloud computing, DevOps pipelines and AI systems.",
    impact: "Satisfies NBA Criterion 8 and NAAC Criterion 6.",
  },
  {
    param: "Quality Enhancement",
    support: "Audit-ready data dashboards and verified student performance records.",
    impact: "Equips the IQAC with transparent, reliable reporting data.",
  },
];

const Accreditation = () => {
  return (
    <section id="accreditation-section" className="accreditation-section">
      <Box sx={{ background: colors.navy, py: { xs: 5, md: 7 } }}>
        <Container>
          <SectionHeading
            light
            eyebrow="NAAC / NBA / IQAC Alignment"
            title="Compliance Becomes a Natural Result of Your Academic Activity"
            subtitle="Crescent EdTech acts as a direct support mechanism for your quality-assurance teams — turning day-to-day engagement into audit-ready evidence."
          />
          <Grid container spacing={2.5}>
            {items.map((it) => (
              <Grid item xs={12} md={6} key={it.param}>
                <Card
                  elevation={0}
                  sx={{
                    ...ui.cardHoverDark,
                    height: "100%",
                    p: 2.75,
                    borderRadius: 3,
                    bgcolor: "rgba(255,255,255,0.04)",
                    border: "1px solid rgba(255,255,255,0.12)",
                    display: "flex",
                    gap: 2,
                  }}
                >
                  <Box
                    sx={{
                      minWidth: 6,
                      alignSelf: "stretch",
                      borderRadius: 3,
                      background: colors.brandGradient,
                    }}
                  />
                  <Box>
                    <Typography
                      sx={{ fontFamily: fonts.heading, fontWeight: 700, color: colors.white, mb: 0.75 }}
                    >
                      {it.param}
                    </Typography>
                    <Typography sx={{ color: "rgba(255,255,255,0.8)", fontSize: "0.9rem", lineHeight: 1.6, mb: 1 }}>
                      {it.support}
                    </Typography>
                    <Typography sx={{ color: colors.blue, fontWeight: 600, fontSize: "0.85rem" }}>
                      → {it.impact}
                    </Typography>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </section>
  );
};

export default Accreditation;
